var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQrScannerMask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 700,
    height: 700,
    viewBox: "0 0 700 700",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M700 30C700 13.4315 686.569 0 670 0H30C13.4315 0 0 13.4315 0 30V670C0 686.569 13.4315 700 30 700H670C686.569 700 700 686.569 700 670V30ZM288 192C262.595 192 242 212.595 242 238V362C242 387.405 262.595 408 288 408H412C437.405 408 458 387.405 458 362V238C458 212.595 437.405 192 412 192H288Z",
    fill: "#081132",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M287.28 188H300.72C301.957 188 302.96 189.003 302.96 190.24C302.96 191.477 301.957 192.48 300.72 192.48H287.28C262.538 192.48 242.48 212.538 242.48 237.28V250.72C242.48 251.957 241.477 252.96 240.24 252.96C239.003 252.96 238 251.957 238 250.72V237.28C238 210.063 260.063 188 287.28 188ZM238 349.28V362.72C238 389.937 260.063 412 287.28 412H300.72C301.957 412 302.96 410.997 302.96 409.76C302.96 408.523 301.957 407.52 300.72 407.52H287.28C262.538 407.52 242.48 387.462 242.48 362.72V349.28C242.48 348.043 241.477 347.04 240.24 347.04C239.003 347.04 238 348.043 238 349.28ZM399.28 412H412.72C439.937 412 462 389.937 462 362.72V349.28C462 348.043 460.997 347.04 459.76 347.04C458.523 347.04 457.52 348.043 457.52 349.28V362.72C457.52 387.462 437.462 407.52 412.72 407.52H399.28C398.043 407.52 397.04 408.523 397.04 409.76C397.04 410.997 398.043 412 399.28 412ZM462 237.28V250.72C462 251.957 460.997 252.96 459.76 252.96C458.523 252.96 457.52 251.957 457.52 250.72V237.28C457.52 212.538 437.462 192.48 412.72 192.48H399.28C398.043 192.48 397.04 191.477 397.04 190.24C397.04 189.003 398.043 188 399.28 188H412.72C439.937 188 462 210.063 462 237.28Z",
    fill: "#F6E9D3"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrScannerMask);
export default __webpack_public_path__ + "static/media/qr-scanner-mask.e5377f73.svg";
export { ForwardRef as ReactComponent };